/**
 * ProductFruits Configuration
 * Single source of truth for feature flag and configuration access
 */

const getHostWindow = () => {
  if (typeof window === 'undefined') {
    throw new Error('ProductFruits config requires a browser environment');
  }
  return window;
};

/**
 * Check if ProductFruits is enabled via feature flag
 */
export const isProductFruitsEnabled = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  const config = getHostWindow().globalConfig;
  return config?.features?.productFruits === true;
};

/**
 * Get ProductFruits configuration from global config
 */
export const getProductFruitsConfig = () => {
  return {
    enabled: isProductFruitsEnabled(),
  };
};

